<div class="box">
  <div class="box-row header">
    <app-header-bar [date]="date" [title]="'dashboard.edit.nav'"></app-header-bar>
  </div>
  <app-error [error]="error"></app-error>
  <div class="content mb-3">
    <div class="row mt-4">
      <p-accordion [multiple]="true">
        <ng-container *ngFor="let item of dashboard?.configuration?.items; let i = index">
          <p-accordion-panel [value]="i.toString()">
            <p-accordion-header>
              <ng-template #toggleicon></ng-template>
              {{ 'dashboard.edit.' + item.component + '.name' | translate }} - {{ item.configuration.title || '' }}
              <div class="btn-group" role="group">
                <button type="button" class="btn btn-sm btn-warning">
                  <span class="material-symbols-outlined">edit</span>
                </button>
                <button
                  type="button"
                  [disabled]="i === 0"
                  (click)="moveWidgetUp(i); $event.stopPropagation()"
                  class="btn btn-sm btn-outline-primary"
                >
                  <span class="material-symbols-outlined">arrow_upward</span>
                </button>
                <button
                  type="button"
                  [disabled]="i === dashboard.configuration.items.length - 1"
                  (click)="moveWidgetDown(i); $event.stopPropagation()"
                  class="btn btn-sm btn-outline-primary"
                >
                  <span class="material-symbols-outlined">arrow_downward</span>
                </button>
                <button type="button" (click)="removeWidget(i); $event.stopPropagation()" class="btn btn-sm btn-danger">
                  <span class="material-symbols-outlined">close</span>
                </button>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <label translate>dashboard.edit.size</label>

              <p-select
                [(ngModel)]="item.size"
                [options]="sizeOptions"
                optionLabel="key"
                optionValue="value"
                appendTo="body"
                class="w-100"
              >
                <ng-template let-selectedOption pTemplate="selectedItem">
                  {{ 'dashboard.edit.sizeOptions.' + selectedOption.key | translate }}
                </ng-template>
                <ng-template let-option pTemplate="item">{{
                  'dashboard.edit.sizeOptions.' + option.key | translate
                }}</ng-template>
              </p-select>

              <app-dashboard-form-wrapper
                [component]="componentRegistry[item.component].form"
                [(data)]="item.configuration"
              ></app-dashboard-form-wrapper>
            </p-accordion-content>
          </p-accordion-panel>
        </ng-container>
      </p-accordion>
    </div>
    <div class="mt-2">
      <p-inputgroup [style]="{ 'width': '300px' }" class="d-inline-flex">
        <p-select [(ngModel)]="newWidget" [options]="widgetTypes" appendTo="body" class="w-100" [placeholder]="'dashboard.edit.addWidget' | translate">
          <ng-template let-selectedOption pTemplate="selectedItem">
            {{ 'dashboard.edit.' + selectedOption + '.name' | translate }}
          </ng-template>
          <ng-template let-option pTemplate="item">{{ 'dashboard.edit.' + option + '.name' | translate }}</ng-template>
        </p-select>
        <p-button severity="success" [disabled]="!newWidget" (click)="addWidget()">
          <span class="material-symbols-outlined">add</span>
        </p-button>
      </p-inputgroup>
      <button class="btn btn-primary float-end" [ladda]="isLoading" (click)="saveDashboard()">
        {{ 'save' | translate }}
      </button>
    </div>
  </div>
</div>
